export const eventMemberCheck = (eventMember: string): number => {
  const eventMemberNumber = parseInt(eventMember);
  if (isNaN(eventMemberNumber)) {
    return -1;
  }

  return Math.sign(eventMemberNumber) === -1 ? -1 : eventMemberNumber;
};
